import { ContextMenuItemState } from "../ContextMenuItemState";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class BfxBlotterOrdersContextMenuItemUnlockState extends ContextMenuItemState {
  public clientCode: string = null;
  public lockType: CubiqTS.LockType = null;

  constructor(
    count: number = 0,
    itemIndex: number = 0,
    available: boolean = true,
    enabled: boolean = true,
    title: string = "",
  ) {
    super(count, itemIndex, available, enabled, title);
  }
}
